"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TextField = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
var _filters = require("../../config/filters");
var _utils = require("../utils");
var _hooks = require("../hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "dropdown": "dropdown_JxIorn",
  "dropdown-header": "dropdown-header_3dOJKT",
  "dropdownHeader": "dropdown-header_3dOJKT",
  "dropdown-content": "dropdown-content_3mQK1J",
  "dropdownContent": "dropdown-content_3mQK1J",
  "dropdown-list": "dropdown-list_32KoMK",
  "dropdownList": "dropdown-list_32KoMK",
  "dropdown-list-item": "dropdown-list-item_1Aa6Bb",
  "dropdownListItem": "dropdown-list-item_1Aa6Bb",
  "clickable-list-item": "clickable-list-item_2kW_Sf",
  "clickableListItem": "clickable-list-item_2kW_Sf",
  "list-item-label": "list-item-label_E7V1bf",
  "listItemLabel": "list-item-label_E7V1bf",
  "list-item-description": "list-item-description_niKmT0",
  "listItemDescription": "list-item-description_niKmT0",
  "dropdown-footer": "dropdown-footer_1Fqse5",
  "dropdownFooter": "dropdown-footer_1Fqse5",
  "dropdown-footer-actions": "dropdown-footer-actions_1G-MJa",
  "dropdownFooterActions": "dropdown-footer-actions_1G-MJa"
}; 
require('./CustomFieldsOptions.css');
const DROPDOWN_OPTIONS_ID = 'custom-fields-dropdown-options';
const CustomFieldsOptions = ({
  options = [],
  onChange,
  value,
  id
}) => {
  const [selectedOptionId, setSelectedOptionId] = (0, _react.useState)(value === null || value === void 0 ? void 0 : value.tagKey);
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  const optionsRef = (0, _react.useRef)();
  const onKeyDown = (0, _hooks.useArrowHandling)(optionsRef, []);
  (0, _react.useEffect)(() => {
    var _optionsRef$current;
    (_optionsRef$current = optionsRef.current) === null || _optionsRef$current === void 0 || _optionsRef$current.focus();
  }, []);
  const filteredOptions = (0, _react.useMemo)(() => options.filter(({
    displayName
  }) => (0, _utils.includesTerm)(displayName, searchTerm)), [options, searchTerm]);
  const onSearchTermChange = (0, _react.useCallback)(({
    value: term
  }) => setSearchTerm(term), []);
  const selectOption = (0, _react.useCallback)(option => {
    setSelectedOptionId(option.tagKey);
    onChange(option);
  }, [onChange]);
  const onClickOption = option => selectOption(option);
  const onKeyDownOption = (event, option) => {
    if (['Enter', ' '].includes(event.key)) {
      selectOption(option);
    }
  };
  const currentOption = options.find(({
    tagKey
  }) => tagKey === selectedOptionId);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    role: "listbox",
    className: styles.dropdown,
    "data-test-id": "custom-fields-filter-dropdown"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdownHeader
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    type: "search",
    placeholder: "Search",
    size: "md",
    onChange: onSearchTermChange,
    value: searchTerm,
    className: styles.searchInput,
    role: "combobox",
    "aria-autocomplete": "list",
    "aria-controls": DROPDOWN_OPTIONS_ID,
    "aria-label": "Search"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdownContent
  }, /*#__PURE__*/_react.default.createElement("ul", {
    id: DROPDOWN_OPTIONS_ID,
    className: styles.dropdownList,
    role: "listbox",
    ref: optionsRef,
    tabIndex: 0,
    onKeyDown: onKeyDown
  }, filteredOptions.map(option => /*#__PURE__*/_react.default.createElement("li", {
    role: "option",
    "aria-selected": !!selectedOptionId && selectedOptionId === currentOption.tagKey,
    className: (0, _classnames.default)(styles.dropdownListItem, styles.clickableListItem),
    key: option.displayName,
    tabIndex: -1,
    onClick: () => onClickOption(option),
    onKeyDown: e => onKeyDownOption(e, option)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.listItemLabel
  }, /*#__PURE__*/_react.default.createElement("span", null, option.displayName, " "), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.listItemDescription
  }, "(", _filters.CUSTOM_FIELDS_TYPES_LABEL[option.dataType], ")")))))));
};
var _default = exports.default = CustomFieldsOptions;
//# sourceMappingURL=CustomFieldsOptions.js.map